import { Locale } from 'chaika-enums';
const mode = {
    canEdit: {
        [Locale.Ru]: 'Редактировать',
        [Locale.Am]: 'Խմբագրել',
        [Locale.En]: 'Edit',
        [Locale.Pt]: 'Editar',
        [Locale.Ge]: 'რედაქტირება',
    },
    canPublish: {
        [Locale.Ru]: 'Опубликовать',
        [Locale.Am]: 'Հրապարակել',
        [Locale.En]: 'Publish',
        [Locale.Pt]: 'Publicar',
        [Locale.Ge]: 'გამოსაქვეყნებლად',
    },
    canDescribe: {
        [Locale.Ru]: 'Начать описание',
        [Locale.Am]: 'Սկսել նկարագրությունը',
        [Locale.En]: 'Done',
        [Locale.Pt]: 'Concluído',
        [Locale.Ge]: 'დაწყება აღწერა',
    },
    canSetReadyForDescribingStatus: {
        [Locale.Ru]: 'Готово',
        [Locale.Am]: 'Պատրաստ է',
        [Locale.En]: 'Start Description',
        [Locale.Pt]: 'Iniciar descrição',
        [Locale.Ge]: 'შესრულებულია',
    },
    onlyView: {
        [Locale.Ru]: 'Распечатать',
        [Locale.Am]: 'Տպել',
        [Locale.En]: 'Print',
        [Locale.Pt]: 'Imprimir',
        [Locale.Ge]: 'ბეჭდვა',
    },
};
const selectOptions = {
    notSelectedOptionMasculine: {
        [Locale.Ru]: 'Не выбран',
        [Locale.Am]: 'Ընտրված չէ',
        [Locale.En]: 'Not selected',
        [Locale.Pt]: 'Não selecionado',
        [Locale.Ge]: 'არ არის შერჩეული',
    },
    notSelectedOptionFeminine: {
        [Locale.Ru]: 'Не выбрана',
        [Locale.Am]: 'Ընտրված չէ',
        [Locale.En]: 'Not selected',
        [Locale.Pt]: 'Não selecionado',
        [Locale.Ge]: 'არ არის შერჩეული',
    },
    anyOptionMasculine: {
        [Locale.Ru]: 'Любой',
        [Locale.Am]: 'Ցանկացած',
        [Locale.En]: 'Anyone',
        [Locale.Pt]: 'Qualquer um',
        [Locale.Ge]: 'ნებისმიერი',
    },
    anyOptionFeminine: {
        [Locale.Ru]: 'Любая',
        [Locale.Am]: 'Ցանկացած',
        [Locale.En]: 'Anyone',
        [Locale.Pt]: 'Qualquer um',
        [Locale.Ge]: 'ნებისმიერი',
    },
    anyOptionNeutral: {
        [Locale.Ru]: 'Все',
        [Locale.Am]: 'Բոլորը',
        [Locale.En]: 'All',
        [Locale.Pt]: 'Todos',
        [Locale.Ge]: 'ყველაფერი',
    },
};
const entryMedicalCaseElements = {
    entryMedicalCases: {
        [Locale.Ru]: 'Эпизоды этой записи',
        [Locale.Am]: 'Այս գրառման էպիզոդները',
        [Locale.En]: 'This entry episodes',
        [Locale.Pt]: 'Episódios desta entrada',
        [Locale.Ge]: 'ამ ჩანაწერის ეპიზოდები',
    },
    openMedicalCases: {
        [Locale.Ru]: 'Открытые эпизоды пациента',
        [Locale.Am]: 'Պացիենտի բաց էպիզոդները',
        [Locale.En]: `Patient's opened episodes`,
        [Locale.Pt]: 'Episódios abertos do paciente',
        [Locale.Ge]: 'ღია პაციენტის ეპიზოდები',
    },
    medicalCaseDiagnoses: {
        [Locale.Ru]: 'Диагнозы',
        [Locale.Am]: 'Ախտորոշումներ',
        [Locale.En]: 'Diagnoses',
        [Locale.Pt]: 'Diagnósticos',
        [Locale.Ge]: 'დიაგნოზი',
    },
    medicalCaseTreatmentPlan: {
        [Locale.Ru]: 'План лечения',
        [Locale.Am]: 'Բուժման պլան',
        [Locale.En]: 'Treatment plan',
        [Locale.Pt]: 'Plano de tratamento',
        [Locale.Ge]: 'მკურნალობის გეგმა',
    },
};
const languages = {
    russian: {
        [Locale.Ru]: 'Русский',
        [Locale.Am]: 'Ռուսերեն',
        [Locale.En]: 'Russian',
        [Locale.Pt]: 'russo',
        [Locale.Ge]: 'რუსული',
    },
    english: {
        [Locale.Ru]: 'Английский',
        [Locale.Am]: 'Անգլերեն',
        [Locale.En]: 'English',
        [Locale.Pt]: 'Inglês',
        [Locale.Ge]: 'ინგლისური',
    },
    georgian: {
        [Locale.Ru]: 'Грузинский',
        [Locale.Am]: 'Վրացերեն',
        [Locale.En]: 'Georgian',
        [Locale.Pt]: 'Georgiano',
        [Locale.Ge]: 'ქართული',
    },
    armenian: {
        [Locale.Ru]: 'Армянский',
        [Locale.Am]: 'հայերեն',
        [Locale.En]: 'Armenian',
        [Locale.Pt]: 'Armênio',
        [Locale.Ge]: 'სომხური',
    },
    arab: {
        [Locale.Ru]: 'Арабский',
        [Locale.Am]: 'Արաբերեն',
        [Locale.En]: 'Arab',
        [Locale.Pt]: 'Árabe',
        [Locale.Ge]: 'Arab',
    },
    chinese: {
        [Locale.Ru]: 'Китайский',
        [Locale.Am]: 'Չինարեն',
        [Locale.En]: 'Chinese',
        [Locale.Pt]: 'Chinês',
        [Locale.Ge]: 'Chinese',
    },
    german: {
        [Locale.Ru]: 'Немецкий',
        [Locale.Am]: 'Գերմաներեն',
        [Locale.En]: 'German',
        [Locale.Pt]: 'Alemão',
        [Locale.Ge]: 'German',
    },
    french: {
        [Locale.Ru]: 'Французский',
        [Locale.Am]: 'Ֆրանսերեն',
        [Locale.En]: 'French',
        [Locale.Pt]: 'Francês',
        [Locale.Ge]: 'French',
    },
    spanish: {
        [Locale.Ru]: 'Испанский',
        [Locale.Am]: 'Իսպաներեն',
        [Locale.En]: 'Spanish',
        [Locale.Pt]: 'Espanhol',
        [Locale.Ge]: 'Spanish',
    },
    portuguese: {
        [Locale.Ru]: 'Португальский',
        [Locale.Am]: 'Պորտուգալերեն',
        [Locale.En]: 'Portuguese',
        [Locale.Pt]: 'Português',
        [Locale.Ge]: 'Portuguese',
    },
    turkish: {
        [Locale.Ru]: 'Турецкий',
        [Locale.Am]: 'Թուրքերեն',
        [Locale.En]: 'Turkish',
        [Locale.Pt]: 'turco',
        [Locale.Ge]: 'Turkish',
    },
    azerbaijani: {
        [Locale.Ru]: 'Азербайджанский',
        [Locale.Am]: 'Ադրբեջաներեն',
        [Locale.En]: 'Azerbaijani',
        [Locale.Pt]: 'Azerbaijano',
        [Locale.Ge]: 'Azerbaijani',
    },
    belorussian: {
        [Locale.Ru]: 'Белорусский',
        [Locale.Am]: 'Բելառուսերեն',
        [Locale.En]: 'Belorussian',
        [Locale.Pt]: 'Bielorrusso',
        [Locale.Ge]: 'Belorussian',
    },
    kazakh: {
        [Locale.Ru]: 'Казахский',
        [Locale.Am]: 'Ղազախերեն',
        [Locale.En]: 'Kazakh',
        [Locale.Pt]: 'Cazaque',
        [Locale.Ge]: 'Kazakh',
    },
    kyrgyz: {
        [Locale.Ru]: 'Киргизский',
        [Locale.Am]: 'Ղրղզերեն',
        [Locale.En]: 'Kyrgyz',
        [Locale.Pt]: 'Quirguiz',
        [Locale.Ge]: 'Kyrgyz',
    },
    moldavian: {
        [Locale.Ru]: 'Молдавский',
        [Locale.Am]: 'Մոլդովերեն',
        [Locale.En]: 'Moldavian',
        [Locale.Pt]: 'Moldávio',
        [Locale.Ge]: 'Moldavian',
    },
    tajik: {
        [Locale.Ru]: 'Таджикский',
        [Locale.Am]: 'Տաջիկերեն',
        [Locale.En]: 'Tajik',
        [Locale.Pt]: 'Tajic',
        [Locale.Ge]: 'Tajik',
    },
    turkmen: {
        [Locale.Ru]: 'Туркменский',
        [Locale.Am]: 'Թուրքմեներեն',
        [Locale.En]: 'Turkmen',
        [Locale.Pt]: 'Turcomeno',
        [Locale.Ge]: 'Turkmen',
    },
    uzbek: {
        [Locale.Ru]: 'Узбекский',
        [Locale.Am]: 'Ուզբեկերեն',
        [Locale.En]: 'Uzbek',
        [Locale.Pt]: 'Uzbeque',
        [Locale.Ge]: 'Uzbek',
    },
    ukrainian: {
        [Locale.Ru]: 'Украинский',
        [Locale.Am]: 'Ուկրաիներեն',
        [Locale.En]: 'Ukrainian',
        [Locale.Pt]: 'ucraniano',
        [Locale.Ge]: 'Ukrainian',
    },
    hebrew: {
        [Locale.Ru]: 'Иврит',
        [Locale.Am]: 'Եբրայերեն',
        [Locale.En]: 'Hebrew',
        [Locale.Pt]: 'Hebraico',
        [Locale.Ge]: 'Hebrew',
    },
    dutch: {
        [Locale.Ru]: 'Голландский',
        [Locale.Am]: 'Հոլանդերեն',
        [Locale.En]: 'Dutch',
        [Locale.Pt]: 'Holandês',
        [Locale.Ge]: 'Dutch',
    },
    monthlyRenewPeriodFem: {
        [Locale.Ru]: 'Ежемесячная',
        [Locale.Am]: 'Ամսական',
        [Locale.En]: 'Monthly',
        [Locale.Pt]: 'Mensal',
        [Locale.Ge]: 'ყოველთვიური',
    },
    annualRenewPeriodFem: {
        [Locale.Ru]: 'Ежегодная',
        [Locale.Am]: 'Տարեկան',
        [Locale.En]: 'Annual',
        [Locale.Pt]: 'Anual',
        [Locale.Ge]: 'ყოველწლიური',
    },
};
export const enums = {
    ...languages,
    ...mode,
    ...selectOptions,
    ...entryMedicalCaseElements,
};
